import { useSettings } from "@/context/SettingsContext";
import { fileUrl } from "@/lib/api";
import { Link } from "react-router-dom";

export default function About() {
  const { settings } = useSettings();
  const about = settings.about || {};
  return (
    <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <p className="label-accent text-kys-accent">Our Story</p>
          <h1 className="mt-3 font-serif text-4xl tracking-tight text-kys-ink sm:text-5xl">{about.heading || "About Kys Boutique"}</h1>
          <p className="mt-6 whitespace-pre-line text-base leading-relaxed text-kys-charcoal">{about.body}</p>
          <Link to="/custom-order" className="mt-8 inline-flex rounded-full bg-kys-ink px-7 py-3 text-sm font-semibold text-white hover:bg-kys-accent">Start a custom order</Link>
        </div>
        <div className="aspect-[4/5] overflow-hidden rounded-lg border border-kys-blush-border bg-kys-blush">
          {about.image && <img src={fileUrl(about.image)} alt="About Kys Boutique" className="h-full w-full object-cover" />}
        </div>
      </div>
    </div>
  );
}
